<template>
  <div>
    <v-row class="mx-6">
    </v-row>
    <v-row class="mx-6">
      <v-col cols="4">
        <v-text-field
          v-model="loginId"
          label="ログインID"
          :counter="10"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row class="mx-6">
      <v-col cols="4">
        <v-text-field
          v-model="password"
          :label="passwordLabel"
          :counter="10"
        ></v-text-field>
        <v-btn small color="secondary" @click="generatePassword()">パスワード自動生成</v-btn>
      </v-col>
    </v-row>
    <v-row class="mx-6">
      <v-col>
        <p class="mb-1">利用可能科目設定</p>
          <v-subject-table/>
      </v-col>
    </v-row>
    <v-btn class="mt-6 ml-6" small color="secondary" dark @click.stop="submit">保存</v-btn>
  </div>
</template>

<script>
import VSubjectTable from '@/components/molecules/SubjectTable'

export default {
  components: {
    VSubjectTable
  },
  data () {
    return {
    }
  },

  methods: {
    async submit() {
      const res = await this.$store.dispatch('account/validate')
      if (res.status === 'error') this.$toasted.global.error({ message: res.message })
      else this.$emit('submit')
    },
    generatePassword() {
      // パスワードをランダムに生成
      // 【パスワード条件：半角英数字、半角記号!#$%&?@が使用可能、8文字】
      const availableMap = "abcdefghjkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789"
      let random = Array.from(Array(availableMap.length)).map((_, index) => availableMap[index])
      random = this.shuffle(random).join('')
      this.$store.commit('account/setPassword', {
        password: random.slice(0, 8)
      })
    },
    shuffle([...array]) {
      for (let i = array.length - 1; i >= 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    },
  },

  computed: {
    passwordLabel() {
      return this.$store.getters['account/passwordLabel']
    },
    loginId: {
      get() {
        return this.$store.state.account.login
      },
      set(value) {
        this.$store.commit('account/setLogin', {
          login: value
        })
      }
    },
    password: {
      get() {
        return this.$store.state.account.password
      },
      set(value) {
        this.$store.commit('account/setPassword', {
          password: value
        })
      }
    },
  }
}
</script>
